// Library Methods
import { createContext } from "react";

// Types
import {
  ExamCommentsType,
  ExamSectionReportType,
} from "src/services/exams/types";

const ReportSectionContext = createContext({
  sectionId: "",
  eyeType: "",
  duration: "",
  durationStartTime: "",
  examReport: {} as ExamSectionReportType,
  commentData: [] as Array<ExamCommentsType>,
});

export { ReportSectionContext };
